import * as React from "react";
const DoorIcon = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        fill="none"

        viewBox={"0 0 976 933"}
        {...props}
    >
      <path
          fill="url(#a)"
          fillRule="evenodd"
          d="M826.95 135.036C742.714 58.734 665.764 24.861 608.853 10.318 580.471 3.065 557.255.666 540.819.128c-8.215-.269-14.732-.073-19.352.214-2.309.143-4.146.309-5.483.45a78.248 78.248 0 0 0-2.349.286l-.078.011-.034.005c-.016.002-.031.005 3.477 23.747l-3.508-23.742C501.72 2.839 493 12.94 493 24.84V418c0 13.255 10.745 24 24 24h435a23.998 23.998 0 0 0 23.504-28.853L952 418c23.504-4.853 23.503-4.86 23.501-4.868l-.004-.018-.009-.046-.028-.132a151.886 151.886 0 0 0-.414-1.884c-.28-1.243-.693-3.017-1.251-5.281-1.117-4.527-2.814-11.016-5.196-19.129-4.76-16.217-12.27-38.981-23.355-65.571-22.122-53.062-58.767-122.039-116.816-184.575a24.23 24.23 0 0 0-1.478-1.46ZM541 394V48.167c13.202.546 32.296 2.607 55.969 8.657C646.143 69.39 715.814 99.35 793.952 169.912c52.675 56.984 86.402 120.252 106.988 169.629 8.957 21.484 15.373 40.211 19.751 54.459H541ZM.429 502C.429 269.803 184.046 80.491 414 71.346V71h5c13.255 0 24 10.745 24 24s-10.745 24-24 24h-5v.389C210.564 128.501 48.429 296.316 48.429 502c0 211.525 171.475 383 383 383 9.895 0 19.703-.375 29.409-1.112l.072.206 6.663-1.504c12.93-2.919 25.778 5.196 28.696 18.125 2.919 12.93-5.196 25.777-18.125 28.696l-1.327.3.312.895c-2.486.262-4.979.503-7.477.722l-.367.083-.011-.05A436.554 436.554 0 0 1 431.429 933c-238.035 0-431-192.965-431-431Zm756.158 202.486C789.438 651.844 809.861 590.647 813.75 525h.25v-6c0-13.255 10.745-24 24-24s24 10.745 24 24v6h-.174c-4.078 77.555-28.658 149.677-68.421 211.048l-.378-.297-6.943 9.104c-8.038 10.54-23.098 12.568-33.637 4.53-10.54-8.038-12.568-23.098-4.53-33.637l8.618-11.302.052.04ZM605.521 843.238a382.866 382.866 0 0 0 46.097-27.821l.213.167 9.971-8.159c10.259-8.393 25.38-6.881 33.773 3.378 8.393 10.258 6.881 25.379-3.377 33.772l-1.695 1.386.334.262a428.68 428.68 0 0 1-6.798 5.028l-2.841 2.324-.147-.179a430.839 430.839 0 0 1-56.153 33.846l.016.041-.483.194-.906.453-.687.341c-.458.228-.917.455-1.376.681l-.088-.252-1.459.583c-12.307 4.924-26.275-1.062-31.198-13.368-4.923-12.307 1.062-26.274 13.369-31.198l3.467-1.387-.032-.092Z"
          clipRule="evenodd"
      />
      <defs>
        <linearGradient
            id="a"
            x1={963.318}
            x2={0.429}
            y1={466.5}
            y2={466.5}
            gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#05C4CE" />
          <stop offset={0.2} stopColor="#00AED5" />
          <stop offset={0.4} stopColor="#009CE1" />
          <stop offset={0.6} stopColor="#008BEC" />
          <stop offset={0.8} stopColor="#0079F7" />
          <stop offset={1} stopColor="#006CFF" />
        </linearGradient>
      </defs>
    </svg>
);
export default DoorIcon;
